import { z } from "zod";

export const issueCreditPayloadSchema = z.object({
  customer_id: z.string().min(1),
  amount: z.number().positive(),
  currency: z.enum(["USD", "EUR", "GBP", "ILS"]),
  memo: z.string().min(1).optional()
});

export type IssueCreditPayload = z.infer<typeof issueCreditPayloadSchema>;
